import { Skeleton } from '@mui/material';
import styles from './LineChartSkeleton.module.css';

const LINES = [...Array(15).keys()];

const BarChartSkeleton = () => {
	return (
		<div className={styles.root}>
			{LINES.map((line) => {
				const height = `${Math.floor(Math.random() * 95)}%`;
				return (
					<Skeleton
						key={line}
						variant='rectangular'
						width={50}
						height={height}
					/>
				);
			})}
		</div>
	);
};

export default BarChartSkeleton;
